import { Typography } from '@mui/material'
import React, { memo, useContext } from 'react'
import tw from 'twin.macro'
import EmptyImage from 'src/assets/images/empty-clipboard.svg'
import EmptySearchImage from 'src/assets/images/empty-search.svg'
import { colors } from 'src/theme'
import { MCsContext } from '../mcs/MCs.context'

const EmptyMCsComponent = () => {
  const { searchQuery } = useContext(MCsContext)

  const isSearchUsed = Boolean(searchQuery)

  return (
    <div css={tw`flex flex-1 h-full justify-center items-center flex-col`}>
      <img src={isSearchUsed ? EmptySearchImage : EmptyImage} />
      <Typography css={tw`mb-1 mt-2`} variant="h4" fontWeight={600}>
        {isSearchUsed ? 'No master contractors found' : 'This board is empty'}
      </Typography>
      <Typography color={colors.SHADES_GREY_400} variant="body2">
        {isSearchUsed
          ? 'Please try a different search query or filters.'
          : 'No contractor records found. Please add new master contractors to see them listed here.'}
      </Typography>
    </div>
  )
}

export const EmptyMCs = memo(EmptyMCsComponent)
